/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from '../pages';
import DefaultLayout from '../../../layouts/default';
import PrivateOutlet from '../../../components/PrivateOutlet';
import { RouteNameEnum } from '../../../enums/routeName';

const BaseRoutes: React.FC = () => (
  <Routes>
    <Route element={<DefaultLayout />}>
      <Route element={<PrivateOutlet />}>
        <Route path={RouteNameEnum.dashboard.index} element={<Dashboard />} />
      </Route>
    </Route>
  </Routes>
);

export default BaseRoutes;
